const WebCheckInReducers = {
  setIsAvailable(state, { payload: value }) {
    state.isAvailable = !!value;
  },
  setBookingDetails({ payload: value }) {
    console.log(value);
  },
};
export { WebCheckInReducers };
export default WebCheckInReducers;
